import {collection,doc,getDoc,getDocs,query,where,orderBy,limit,startAfter,addDoc,runTransaction,serverTimestamp} from 'firebase/firestore';
import {auth,db} from '../../firebase';
import {salesAccess,leadPayload,duplicates} from './salesModel';
export async function getSalesContext() {
 const uid=auth.currentUser?.uid; if(!uid) throw new Error('Sign in to access Sales.');
 const [u,a]=await Promise.all([getDoc(doc(db,'users',uid)),getDoc(doc(db,'accessProfiles',uid))]);
 if(auth.currentUser?.uid!==uid || !salesAccess(u.data(),a.data(),uid)) throw new Error('Sales requires active canonical Owner Admin access.');
 return {uid,tenantId:a.data().tenantId};
}
export function leadsQuery(context,cursor) {
 return query(collection(db,'salesLeads'),where('tenantId','==',context.tenantId),orderBy('__name__'),...(cursor?[startAfter(cursor)]:[]),limit(100));
}
export async function readLeadPage(context,cursor) {
 const fresh=await getSalesContext(); if(fresh.uid!==context.uid || fresh.tenantId!==context.tenantId) throw new Error('Sales access changed. Reload Sales.');
 const snap=await getDocs(leadsQuery(fresh,cursor));
 return {rows:snap.docs.map(d=>({...d.data(),id:d.id})),cursor:snap.docs.at(-1),more:snap.size===100};
}
export async function findDuplicates(draft) {
 const context=await getSalesContext(); let cursor, more=true, found=[];
 while(more) {const page=await readLeadPage(context,cursor);found.push(...duplicates(page.rows,draft));cursor=page.cursor;more=page.more;}
 return found;
}
export async function saveLead(draft,id,expectedContext) {
 const context=await getSalesContext();
 if(context.uid!==expectedContext.uid || context.tenantId!==expectedContext.tenantId) throw new Error('Sales access changed. Reopen the lead.');
 const data={...leadPayload(draft),updatedBy:context.uid,updatedAt:serverTimestamp(),...(draft.recordContact?{lastContactAt:serverTimestamp()}:{})};
 if(!id) return addDoc(collection(db,'salesLeads'),{...data,tenantId:context.tenantId,createdBy:context.uid,createdAt:serverTimestamp()});
 return runTransaction(db,async tx=>{const ref=doc(db,'salesLeads',id),snap=await tx.get(ref);
 if(!snap.exists() || snap.data().tenantId!==context.tenantId) throw new Error('Lead is not in your tenant.');
 tx.update(ref,data);
 });
}
export async function salesMetadata(context) {
 const [tenant,owners]=await Promise.all([getDoc(doc(db,'tenants',context.tenantId)),getDocs(query(collection(db,'accessProfiles'),where('tenantId','==',context.tenantId),where('role','==','owner_admin'),limit(100)))]);
 const eligible=[];
 for(const owner of owners.docs) {const u=await getDoc(doc(db,'users',owner.id));if(salesAccess(u.data(),owner.data(),owner.id)) eligible.push({uid:owner.id,name:u.data()?.displayName||u.data()?.email||owner.id});}
 return {timezone:tenant.data()?.timeZone||tenant.data()?.timezone,owners:eligible};
}
